import Vue from 'vue'
export const userKey = '__sige_user'
export const baseApiUrl = process.env.VUE_APP_BASEAPIURL
export const clone = require('lodash.clone')
export const cloneDeep = require('lodash.clonedeep')

export function showLoading() {
    Vue.toasted.global.defaultLoading({ msg: 'Realizando Ação...' })
}

export function showSuccess(payload, scope, mode) {
    if (payload && payload.data && payload.data.errors) {
        for (var data in payload.data) {
            const el = payload.data[data]
            
            if (el.message) { 
                if (data === 'errors') {
                    Vue.toasted.global.defaultError({ msg: el.message }) 
                } else if (data === 'import') {
                    Vue.toasted.global.defaultInfo({ msg: el.message })
                } else {
                    Vue.toasted.global.defaultSuccess({ msg: el.message }) 
                }
            }
        }
    } else if (typeof payload.data === 'string') {
        Vue.toasted.global.defaultSuccess({ msg : payload.data })
    } else {
        let msg = ''
        switch (scope) {
            case 'planningGoalById':
                msg = (mode === 'edit') ? 'Ação Editada!' : ''
                break;
        
            default:
                break;
        }

        Vue.toasted.global.defaultSuccess({ msg })
    }
}
export function showError(payload) {
    if (payload.response && payload.response.status && payload.response.status == '500') {
        Vue.toasted.global.defaultError({ msg: 'Erro interno! Contacte o desenvolvedor.' })
    } 
    else if (payload.response && payload.response.data && (typeof payload.response.data == 'object')) {
        for (var x in payload.response.data) {
            const el = payload.response.data[x]
            if (el.message) { 
                Vue.toasted.global.defaultError({ msg: el.message }) 
            } else if (typeof el == 'object') {
                for (var z in el) {
                    const el2 = el[z]
                    if (el2.message) { 
                        Vue.toasted.global.defaultError({ msg: el2.message }) 
                    }
                }
            }
        }
    } else if (typeof payload !== 'undefined') {
        Vue.toasted.global.defaultError({ msg : payload })
    } else {
        Vue.toasted.global.defaultError({ msg : '' })
    }
}

export default { baseApiUrl, showSuccess, showError, showLoading, userKey, clone, cloneDeep }